const CRITICAL_PERIOD_STYLE =
  'color: #1F1F1F; background: repeating-linear-gradient(315deg, #F5BBB7, #F5BBB7 5px, #E8EDEC 5px, #E8EDEC 10px);'

export const CRITICAL_PERIOD_SELECTOR = '.b-critical-period, .b-critical-period-future'

const getHiddenUntil = (period, timelineEnd) =>
  period.hidden_until_resolution ? timelineEnd : period.hidden_until && new Date(period.hidden_until)

export const getCriticalPeriodTimeRanges = ({ period, now, timelineEnd, name, futureName }) => {
  const periodData = { codes: period.codes, periodStartedOn: period.started_on, periodEndedOn: period.ended_on }
  const ranges = [
    {
      ...periodData,
      id: period.id,
      cls: 'b-critical-period',
      name,
      resourceId: period.vehicle_id,
      startDate: new Date(period.started_on),
      endDate: period.ended_on ? new Date(period.ended_on) : now,
      style: CRITICAL_PERIOD_STYLE,
    },
  ]
  const hiddenUntil = getHiddenUntil(period, timelineEnd)
  if (!period.ended_on && hiddenUntil > now) {
    ranges.push({
      ...periodData,
      id: `${period.id}-future`,
      cls: 'b-critical-period-future',
      name: futureName,
      resourceId: period.vehicle_id,
      startDate: now,
      endDate: hiddenUntil,
      style: `${CRITICAL_PERIOD_STYLE} opacity: 0.5;`,
    })
  }
  return ranges
}
